/** The Pre-check-in tab's field catalog: the tour editor's pre-check-in fields
 *  (`precheckFieldsCatalog`, the same labels and help — the wording rule) under the
 *  operator's record, plus its custom fields (`definitions`). */
import { precheckFieldsCatalog } from '@/features/tours/record/catalog';
import type { RecordField } from '@/features/records/editor/types';

import { DEFINITIONS_PATH, OPERATOR_ENTITY, TEXT_MAX_LENGTH } from './model';

export const OPERATOR_MANAGE_PERM = 'console_top_manage';

const TEXT_KEYS = new Set(['pre_check_settings.intro_text', 'pre_check_settings.confirmation_message']);

export const OPERATOR_PRECHECK_FIELDS: RecordField[] = [
  ...precheckFieldsCatalog(OPERATOR_ENTITY, OPERATOR_MANAGE_PERM).map((f) =>
    TEXT_KEYS.has(f.key) ? { ...f, max_length: TEXT_MAX_LENGTH } : f,
  ),
  {
    key: DEFINITIONS_PATH,
    entity: OPERATOR_ENTITY,
    label: 'Custom fields',
    kind: 'editable',
    widget: 'precheck_definitions',
    choices: [],
    nullable: false,
    guards: [],
    permissions: [OPERATOR_MANAGE_PERM],
    follows_lead: false,
    effects: [],
    automatic: [],
    restech_rule: null,
  },
];

export const OPERATOR_PRECHECK_FIELD_BY_KEY: ReadonlyMap<string, RecordField> = new Map(
  OPERATOR_PRECHECK_FIELDS.map((f) => [f.key, f]),
);
